import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTORS_QUERY_KEYS } from "Actors/Api/Queries/queryKeys";
import {
  postActorsActorIDPriceCategories,
  type SaveActorPriceCategoriesRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

export function useSaveActorPriceCategoriesMutation(actorID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (data: SaveActorPriceCategoriesRequest) =>
        postActorsActorIDPriceCategories(data, actorID),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.SaveActorPriceCategories,
        ),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.priceCategories(actorID),
      });
    },
  });
}
